export default {"src":"/_next/static/media/aeur.b78d5b9e.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};